<template>
  <van-popup
    v-model="open"
    class="popup"
    position="bottom"
    :safe-area-inset-bottom="true"
    @click-overlay="close"
  >
    <div class="top fixwh">
      <div class="close" @click="close">取消</div>
      <div class="title">选择出售品类</div>
    </div>
    <div class="search fixwh">
      <div class="s-in">
        <!-- <div>xx</div> -->
        <van-field
          v-model="value"
          clearable
          label=""
          left-icon="search"
          class="in"
          placeholder="请输入货品名称，自动帮您匹配分类"
          @input="changeText"
        >
          <i slot="left-icon" class="iconfont-new icon-search-line" />
        </van-field>
      </div>
      <!-- <div class="btn" @click="() => search(1)">搜索</div> -->
    </div>
    <div class="pannel">
      <div v-for="item,k in list" :key="k" class="pannel-item" @click="ck(k)">
        {{ item.text }}
      </div>
    </div>
  </van-popup>
</template>
<script>
import Vue from 'vue'
import { getCates } from '@/api/common'
import { isEmpty } from '@/utils'
export default {
  name: 'Cates',
  props: {
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      value: '',
      list: []
    }
  },
  methods: {
    ck(i) {
      const item = this.list[i]
      this.$emit('selectCate', item)
      this.close()
    },
    changeText: Vue._.debounce(
      async function(e) {
        if (isEmpty(e)) {
          this.list = []
          return
        }
        try {
          const res = await getCates({ count: 30, keyword: e }) || []
          this.list = res
        } catch (e) {
          console.error(e)
        }
      },
      200,
      {
        leading: false,
        trailing: true
      }
    ),
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>
<style lang="less" scoped>
.supplys {
  flex-grow: 1;
  overflow-y: scroll;
}
.close {
  position: absolute;
  left: 30px;
  font-family: PingFangSC-Medium;
  font-size: 34px;
  color: #333333;
  font-weight: 500;
  top: 20px;
  height: 48px;
  line-height: 48px;
}
.popup {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.top {
  margin-top: var(--hn-top-safearea);
  display: flex;
  height: 88px;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
}
.title {
  font-family: PingFangSC-Medium;
  font-size: 34px;
  color: #333333;
  text-align: center;
  font-weight: 500;
}
.search {
  display: flex;
  height: 88px;
  width: 100%;
  align-items: center;
  padding: 0 30px;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
}
.s-in {
  background: #f3f3f3;
  flex-grow: 1;
  border-radius: 30px;
  height: 60px;
  display: flex;
  overflow: hidden;
  padding: 0 20px;
  box-sizing: border-box;
}
.in {
  border: none 0;
  outline: none 0;
  flex-grow: 1;
  height: 60px;
  line-height: 60px;
  background: #f3f3f3;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #909090;
  letter-spacing: 0;
  font-weight: 400;
  padding: 0;
  /deep/ .iconfont-new {
    color: #909090;
  }
}
.pannel{
  flex-grow:1;
  overflow-y: scroll;
  .pannel-item{
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
       border-bottom: 1px solid #f5f5f5;
       box-sizing: border-box;
       padding: 0 30px;
  }
}
</style>
